import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays a product's availability based on the selected variant.
 * This component listens for variant update events and updates the availability display accordingly.
 */
class ProductAvailability extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateAvailability);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateAvailability);
  }

  /**
   * Updates the availability display when a variant is selected.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateAvailability = (event) => {
    // Check if this update is for the correct product
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Find the updated availability element in the new HTML
    const newAvailability = event.detail.data.html.querySelector('product-availability');
    
    if (!newAvailability) return;

    // Use morph to update the content, just like other product components
    morph(this, newAvailability, { childrenOnly: true });
  };
}

// Register the custom element
if (!customElements.get('product-availability')) {
  customElements.define('product-availability', ProductAvailability);
}

export default ProductAvailability; 